// extracted by mini-css-extract-plugin
module.exports = {"TitleContainer":"template-module--TitleContainer--36117","Title":"template-module--Title--32h4O","ContentContainer":"template-module--ContentContainer--3GOPh"};